import { render, staticRenderFns } from "./EmailInputDropdown.vue?vue&type=template&id=5fd10f52&scoped=true&"
import script from "./EmailInputDropdown.vue?vue&type=script&lang=js&"
export * from "./EmailInputDropdown.vue?vue&type=script&lang=js&"
import style0 from "./EmailInputDropdown.vue?vue&type=style&index=0&id=5fd10f52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd10f52",
  null
  
)

export default component.exports